export default __webpack_public_path__ + "static/media/teenage-prick.a3ae698e.png";